import appConfigs from "@configs/app.ts";

const fnQ: (() => void)[] = [];

const processQ = () => {
  if (fnQ.length) {
    fnQ[0]();
    fnQ.shift();
    if (fnQ.length) {
      setTimeout(() => {
        processQ();
      }, 100);
    }
  }
};

const loadWirisPlugin = (fn: () => void) => {
  if (window.WIRIS_PLUGIN_LOADED) {
    fn();
  } else if (window.WIRIS_PLUGIN_LOADING) {
    fnQ.push(fn);
  } else {
    window.WIRIS_PLUGIN_LOADING = true;
    const scriptEl = document.createElement("script");
    scriptEl.setAttribute("src", appConfigs.wirisPluginJs);
    scriptEl.onload = () => {
      window.WIRIS_PLUGIN_LOADED = true;
      processQ();
    };
    loadWirisPlugin(fn);
    document.head.appendChild(scriptEl);
  }
};

export { fnQ, loadWirisPlugin };
